import { Box, Grid, Typography } from '@mui/material'
import { t } from 'i18next'


const ReviewActionNotification = ({ actionName, notificationConfig }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        marginY={2}
        spacing={2}
      >
        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.actionName')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography>{actionName}</Typography>
        </Grid>

        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.emailsToNotify')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography>
            {notificationConfig.emailsToNotify.map((mail) => `${mail} `)}
          </Typography>
        </Grid>

        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.notifyAdmin')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography>
            {notificationConfig.notifyAdmin ? 'Si' : 'No'}
          </Typography>
        </Grid>

        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.notifyEditor')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography>
            {notificationConfig.notifyEditor ? 'Si' : 'No'}
          </Typography>
        </Grid>

        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.notifyEditor')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography>
            {notificationConfig.notifyViewer ? 'Si' : 'No'}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ReviewActionNotification
